const AdminReportPseudoActivation = () => import('./views/AdminReportPseudoActivation.vue')
export default [
    {
        path: '/project/:id/GCB2/adminReportActivation',
        name: 'GCB2AdminReportActivation',
        component: AdminReportPseudoActivation,
    },
]
